<template>
    <div class="dashboard">
        <template>
            <el-card style='padding:0px 5px 0px 5px' v-loading="rowLoading">
                <div style='width:49%;padding-right:1%;float:left;border-right:1px dashed #ccc;'>
                    <h5 class='mb5 green' ><i  class='el-icon-lx-calendar icon2 size20'></i>{{form1.dayType==1?"":form1.dayType==2?"近30天":form1.dayType==3?"近7天":"-"}} 整体数据</h5>
                    <el-row   :gutter="5" type="flex" justify="space-between">
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-lx-roundcheckfill icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value" v-animate-number="tsData.total"></div>
                                            <div class="card-title">请求量</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-lx-roundcheckfill icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value" v-animate-number="tsData.success"></div>
                                            <div class="card-title">订购量</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-lx-timefill icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value percent" v-animate-number:2="tsData.successAvg" > </div>
                                            <div class="card-title">订购率</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div style='width:49%;float:right;' >
                    <h5 class='mb5' style='text-align: right;margin-top:-5px'><span class='label6' style='margin-top:-5px'><i class='el-icon-lx-filter pointer' @click="selectGoods('1')"></i></span></h5>
                    <el-row   :gutter="5" type="flex" justify="space-between">
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-s-help icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value percent" v-animate-number:2="tsData.smsAvg"></div>
                                            <div class="card-title">短信下发率</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-s-help icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value percent" v-animate-number:2="tsData.submitSmsAvg" ></div>
                                            <div class="card-title">短信回填</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-s-help icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value percent" v-animate-number:2="tsData.backSmsAvg" > </div>
                                            <div class="card-title">回填订购率</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div style='width:49%;padding-right:1%;float:left;border-right:1px dashed #ccc;'>
                    <el-row   :gutter="5" type="flex" justify="space-between">
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-lx-roundcheckfill icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value" v-animate-number="tsData.cancel"></div>
                                            <div class="card-title">退订量</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-lx-roundcheckfill icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value percent" v-animate-number:2="tsData.cancelAvg"></div>
                                            <div class="card-title">退订率</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-lx-timefill icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value"  v-animate-number="tsData.complaint"></div>
                                            <div class="card-title">投诉量</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div style='width:49%;float:right;' >
                     <el-row   :gutter="5" type="flex" justify="space-between">
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-s-help icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value percent" v-animate-number:2="tsData.complaintAvg"></div>
                                            <div class="card-title">投诉率</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-s-help icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value percent" v-animate-number:2="tsData.interceptAvg"> </div>
                                            <div class="card-title">拦截率</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                        <el-col :span="12" >
                            <div class="card-container">
                                <el-card class="top-card">
                                    <div class="card-content">
                                        <i class="el-icon-s-help icon" ></i>
                                        <div class="text-content iconJump">
                                            <div class="card-value percent" v-animate-number:2="tsData.cmlAvg" > </div>
                                            <div class="card-title">插码率</div>
                                        </div>
                                    </div>
                                </el-card>
                                <div class="hover-layer"></div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div style='clear:both'></div>
            </el-card>

            <div class="chart-rows">
                <el-row v-loading="schartLoading" :gutter="2" style="margin-top: 2px;">
                    <el-card class='mt5' >
                        <div style='width:49%;padding-right:1%;float:left; border-right:1px dashed #ccc;'>
                            <h5 style='text-align: center;color:green'>{{form1.dayType==1?"":form1.dayType==2?"近30天":form1.dayType==3?"近7天":"-"}}退订包名排行</h5>
                            <el-table v-loading='sortLoading' :data="tableData1"  style="margin-top:5px;" row-key="superiorId" :highlight-current-row="true"  max-height="400">
                                <el-table-column label="序号" width="50" align="center" type="index">
                                </el-table-column>
                                <el-table-column label="APP包名" min-width="120" align="left" prop="message">
                                    <template slot-scope="scope">
                                        <p class='size12'>{{scope.row.appPackage}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column label="触点名称" min-width="120" align="left" prop="total">
                                    <template slot-scope="scope">
                                        <p class='size12'>{{scope.row.platform}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column label="屏蔽状态" width="80" align="center" prop="avg">
                                    <template slot-scope="scope">
                                        <el-tooltip :content="scope.row.isBlack=='1'?'已屏蔽':'未屏蔽'" placement="top">
<!-- @change="handleStatus(scope.$index, scope.row)"                                           -->
                                            <el-switch
                                                       v-model="scope.row.isBlack"
                                                       active-color=""
                                                       inactive-color="red"
                                                       active-value="1"
                                                       inactive-value="0">
                                            </el-switch>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                                <el-table-column label="退订占比" width="180" align="center" prop="avg">
                                    <template slot-scope="scope">
                                        <el-progress :text-inside="true" :stroke-width="20" :percentage="scope.row.avg"
                                                     color="#ff0000 "></el-progress>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div style='width:49%;float:right;' >
                            <h5 style='text-align: center;color:green'>{{form1.dayType==1?"":form1.dayType==2?"近30天":form1.dayType==3?"近7天":"-"}}投诉包名排行</h5>
                            <el-table v-loading='sortLoading' :data="tableData2" style="margin-top:5px;" row-key="superiorId" :highlight-current-row="true"  max-height="400">
                                <el-table-column label="序号" width="60" align="center" type="index">
                                </el-table-column>
                                <el-table-column label="APP包名" min-width="120" align="left" prop="message">
                                    <template slot-scope="scope">
                                        <p class='size12'>{{scope.row.appPackage}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column label="触点名称" min-width="120" align="left" prop="total">
                                    <template slot-scope="scope">
                                        <p class='size12'>{{scope.row.platform}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column label="屏蔽状态" width="80" align="center" prop="avg">
                                    <template slot-scope="scope">
                                        <el-tooltip :content="scope.row.isBlack=='1'?'已屏蔽':'未屏蔽'" placement="top">
<!--@change="handleStatus(scope.$index, scope.row)"                                            -->
                                            <el-switch
                                                       v-model="scope.row.isBlack"
                                                       active-color=""
                                                       inactive-color="red"
                                                       active-value="1"
                                                       inactive-value="0">
                                            </el-switch>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                                <el-table-column label="投诉占比" width="180" align="center" prop="avg">
                                    <template slot-scope="scope">
                                        <el-progress :text-inside="true" :stroke-width="20" :percentage="scope.row.avg"
                                                     color="#ff0000 "></el-progress>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div style='clear:both'></div>
                    </el-card>
                    <el-card class='mt5' v-loading='detailLoading'>
                        <h5 class='mb5 green'  ><i  class='el-icon-lx-favorfill icon2 size20'></i> {{form1.dayType==1?"":form1.dayType==2?"近30天":form1.dayType==3?"近7天":"-"}}渠道数据</h5>
                        <el-table :data="tableData3" border style="margin-top:5px;" row-key="superiorId" :highlight-current-row="true"  max-height="400">
                            <el-table-column label="下游渠道" fixed="left" min-width="120" align="left" prop="message">
                                <template slot-scope="scope">
                                    <p class='size12'>{{scope.row.name}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="产品名称" fixed="left" min-width="220" align="left" prop="total">
                                <template slot-scope="scope">
                                    <p class='size12'>{{scope.row.pname}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="请求量" min-width="80" align="left" prop="total">
                                <template slot-scope="scope">
                                    <p class='size12'>{{scope.row.total}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="订购量" min-width="80" align="left" prop="total">
                                <template slot-scope="scope">
                                    <p class='size12'>{{scope.row.success}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="扣量数" min-width="80" align="left" prop="total">
                                <template slot-scope="scope">
                                    <p class='size12'>{{scope.row.deduction}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="订购率" min-width="80" align="left" prop="total">
                                <template slot-scope="scope">
                                    <p class='size12 percent'>{{scope.row.successAvg}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="短信下发率" min-width="100" align="left" prop="total">
                                <template slot-scope="scope">
                                    <p class='size12 percent'>{{scope.row.smsAvg}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="短信回填" min-width="100" align="left" prop="total">
                                <template slot-scope="scope">
                                    <p class='size12'>{{scope.row.submitSms}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="回填订购率" min-width="100" align="left" prop="total">
                                <template slot-scope="scope">
                                    <p class='size12 percent'>{{scope.row.backSmsAvg}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="退订量" min-width="80" align="left" prop="total">
                                <template slot-scope="scope">
                                    <p class='size12'>{{scope.row.cancel}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="退订率" min-width="80" align="left" prop="total">
                                <template slot-scope="scope">
                                    <p class='size12 percent'>{{scope.row.cancelAvg}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="投诉量" min-width="80" align="left" prop="total">
                                <template slot-scope="scope">
                                    <p class='size12'>{{scope.row.complaint}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="投诉率" min-width="80" align="left" prop="total">
                                <template slot-scope="scope">
                                    <p class='size12 percent'>{{scope.row.complaintAvg}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="拦截率" min-width="80" align="left" prop="total">
                                <template slot-scope="scope">
                                    <p class='size12 percent'>{{scope.row.interceptAvg}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column label="插码率" min-width="80" align="left" prop="total">
                                <template slot-scope="scope">
                                    <p class='size12 percent'>{{scope.row.cmlAvg}}</p>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>

                </el-row>
            </div>

        </template>
        <el-drawer title="产品筛选" :visible.sync="editVisible" direction="rtl" :append-to-body='true' width="500px" >
            <el-form style='margin-left:10px;' ref="form1" :model="form1" label-width="120px">
                <span class="label-span">
                    <label class="label">上游资源</label>
                    <el-select class="mr10" v-model="form1.channelCode" @change='getSelect' placeholder="资源名称" style="width:285px;"
                               filterable clearable>
                        <el-option value="" label="所有资源" />
                        <el-option v-for="item in select1.option" :key="item.id" :label="item.optVal"
                                   :value="item.optKey" />
                    </el-select>
                </span>
                <span class="label-span">
                    <label class="label">产品名称</label>
                    <el-select class="mr10" v-model="form1.goodsCode" placeholder="资源名称" style="width:285px;"
                               filterable clearable>
                        <el-option value="" label="所有产品" />
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal"
                                   :value="item.optKey" />
                    </el-select>
                </span>
                <span class="label-span">
                    <label class="label">查询日期</label>
                    <el-radio-group v-model.trim="form1.dayType" >
                        <el-radio-button label="1">全部时间</el-radio-button>
                        <el-radio-button label="2">近 30天</el-radio-button>
                        <el-radio-button label="3">近 7 天</el-radio-button>
                    </el-radio-group>
                </span>
                <br>
                <el-button style='margin-top:10px;width: 100px;font-size: 15px;height: 35px;' type="primary" @click="queryByForm()">{{ isSubmitting ? '查询中...' : '确 认' }}</el-button>
            </el-form>
        </el-drawer>
    </div>
</template>

<script>



import {
    findDataByDataBody6
} from '../../../api/orderStatistics/orderStatustucs';

import { fetchSelect3 as fetchSelect } from '../../../api/comGoods';
import numeral from 'numeral';
import { fetchSelect as fetchSelect1 } from '@/view/channel/channel';

export default {
    name: 'charts',
    data() {
        return {
            rowLoading: false,
            schartLoading: false,
            schartLoading1: false,
            detailLoading: false,
            sortLoading: false,
            memloading2: false,
            memloading1: false,
            editVisible:false,
            lastTotalAvg: 0,
            refreshProgress: 100, // 初始进度为100%
            refreshCountdown: 10, // 初始倒计时为10秒
            refreshInterval: null,// 存储定时器ID
            chartHeight :160,
            form1:{dayType:3},
            select:{option:''},
            select1:{option:''},
            tsData:{
                total: 0,
                success: 0,
                successAvg: 0,
                smsAvg: 0,
                submitSmsAvg: 0,
                backSmsAvg: 0,
                cancel: 0,
                cancelAvg: 0,
                complaint: 0,
                complaintAvg: 0,
                interceptAvg: 0,
                cmlAvg: 0

            },
            tableData1:[],
            tableData2:[],
            tableData3:[],
            query:{},
            goodsFag:'1',
        };
    },

    beforeDestroy() {
    },
    created() {  },
    mounted() {
        this.initData();

        this.getSelect1();
        this.getSelect();
    },
    computed: {  },
    methods: {
        queryByForm(){
            this.rowLoading =true;
            this.sortLoading =true;
            this.detailLoading =true;
            console.log("进行body6的统计查询==>",this.form1);
            findDataByDataBody6(this.form1).then(res => {
                    console.log("body6查询结果==>",res)
                if(res.code=='200'){
                    this.tsData = res.data.top;
                    this.tableData1 = res.data.tdList;
                    this.tableData2 = res.data.tsList;
                    this.tableData3 = res.data.agentList;
                    console.log("tsData==>",this.tsData);
                }
                this.rowLoading =false;
                this.sortLoading =false;
                this.detailLoading =false;
            });
        },
        // 编辑操作
        selectGoods(i) {
            this.goodsFag = i;
            this.editVisible = true;
        },
        initData(){
            this.queryByForm();
        },
        getSelect(){
            this.select = {};
            this.select.channelCode = this.form1.channelCode;
            fetchSelect(this.select).then(res => {
                if(res.code=='200'){
                    this.$set(this.select, 'option', res.data);
                }
            });
        },
        getSelect1(){
            this.select1 = {};
            fetchSelect1(this.select1).then(res => {
                if(res.code=='200'){
                    this.$set(this.select1, 'option', res.data);
                }
            });
        },

    }
};

</script>


<style scoped>
.percent::after {
    content: '%';
    margin-left: 2px;
}
.dashboard {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    padding: 5px;
}
.chart-rows {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.card-container {
    width: 96%;
    margin: 0px 2%;
    position: relative;
    overflow: visible;
}

.top-card {
    height: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 5px 0;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.8);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
    z-index: 2;
    position: relative;
}

.card-title {
    font-size: 12px;
    margin-top: 0; /* 移除顶部间距 */
    text-align: center;
    color:#666;
}
.card-title2 {
    font-size: 13px;
    margin-top: 0; /* 移除顶部间距 */
    text-align: center;
    color: #666;
}

.card-value {
    font-size: 15px;
    font-weight: bold;
    margin-top: 5px;
    text-align: center;
    color: #666;
}
.card-value2 {
    font-size: 25px;
    font-weight: bold;
    margin-top: 5px;
    text-align: center;
    color: rgba(2, 174, 7, 0.8);
}

.el-col-4 {
    width: 16.6%;
}

.hover-layer {
    border-radius: 10px;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, #7ebcfd, #7ebcfd);
    transform: scale(0);
    transform-origin: center center;
    opacity: 0.6;
    transition: all 0.4s ease-in-out;
    z-index: 1;
    pointer-events: none;
}

.card-container:hover .hover-layer {
    transform: scale(1);
    opacity: 1;
}
.card-value span {
    font-weight: normal;
}

.card-value .positive {
    color: #2ecc71; /* 鲜亮绿色，表示增长 */
}

.card-value .negative {
    color: #e74c3c; /* 鲜艳红色，表示下降 */
}
.echartswh {
    padding:10px 2%;
    width: 96%;
    height: 100%; /* 自动继承父容器高度 */
    min-height: 180px; /* 最小高度兜底 */

}
.echartswh1{
    padding:10px 2%;
    width: 96%;
    height: 100%; /* 自动继承父容器高度 */
    min-height: 210px; /* 最小高度兜底 */
}
.echartswh2{
    width: 100%;
    height: 100%;
    min-height: 180px; /* 最小高度兜底 */
}

.icon {
    font-size: 40px;
    height: 100px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    vertical-align: middle;
    color: rgb(9, 169, 22);
    position: absolute;
    left:20px;
}
.icon2 {
    font-size: 20px;
    color: rgb(9, 169, 22);
}
.card-content {
    display: flex;
    align-items: center;
}
.text-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center; /* 确保文本居中对齐 */
}
@media (max-width: 768px) {
    .el-col-4 {
        width: 50%; /* 手机端两列显示 */
        margin-bottom: 10px;
    }
}
@media (min-width: 769px) and (max-width: 1024px) {
    .el-col-4 {
        width: 33.33%; /* 平板三列显示 */
    }
}

.el-row {
    margin-bottom: 2px !important;
}
.mt5{
    margin-top:5px !important;
}
/*
.card-content{
       内联元素（inline）动画不起作用， 因此要设置为‘inline-block’
       animation: jump2 2s infinite ease-in-out;
       animation-delay: var(--delay);
     }

     @keyframes jump2 {
       100% {
         transform: translateY(0);
       }
       50% {
         transform: translateY(-10px);
       }
     } */

.iconJump2 {
    color: #409EFF;
    background-image: -webkit-linear-gradient(90deg, #409EFF, #01ac25);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-animation: change2 5s infinite linear;
}
@-webkit-keyframes change2 {
    from {
        -webkit-filter: hue-rotate(0deg);
    }
    to {
        -webkit-filter: hue-rotate(-360deg);
    }
}

</style>
